import apiHelpers from './apiHelpers.js';
import { mapCrudStoreGen } from '@/helpers/utils/storeHelpers.js';
let defaultForm = {
  zoneLookupMapType: 'MapByCountryCode',
  carrier: '',
  service: '*',
  fromWarehouseId: '',
  countryCode: '',
  postCode: '',
  postCodeRangeFrom: null,
  postCodeRangeTo: null,
  mapsToZoneId: ''
};

let defaultFilters = {
  zoneLookupMapType: '',
  carrier: '',
  service: '',
  fromWarehouseId: '',
  countryCode: '',
  postCode: '',
  mapsToZoneId: ''
};

let genedStore = mapCrudStoreGen(defaultForm, defaultFilters, apiHelpers);

export default {
  namespaced: true,

  state: () => ({
    ...genedStore.state
  }),

  mutations: {
    ...genedStore.mutations
  },

  getters: {
    ...genedStore.getters
  },

  actions: {
    ...genedStore.actions
  },
};